import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";

export const useMainMenuHandling = () => {
    const {t: translation} = useTranslation('common');

    const masterdataExpandedKey = "masterdata-expanded";

    const [expandedMasterdata, setExpandedMasterdata] = useState<boolean>(() => {
        const savedState: string | null = localStorage.getItem(masterdataExpandedKey);
        return savedState !== null ? JSON.parse(savedState) : true;
    });

    useEffect(() => {
        localStorage.setItem(masterdataExpandedKey, JSON.stringify(expandedMasterdata));
    }, [expandedMasterdata]);

    const handleClickStammdaten = () => {
        setExpandedMasterdata(prev => !prev);
    }

    return {
        translation,
        expandedMasterdata,
        handleClickStammdaten,
    }
}